<template>
  <div class="footer__normal global-margin">
    <div
      class="flex no-wrap justify-between items-center"
      v-if="screenWidth > 1024"
    >
      <div class="left flex" style="display: flex">
        <img
          class="qrcode"
          src="../assets/images/qrcode.png"
          :alt="$t('home.p1')"
        />
        <div class="address flex flex-column justify-around">
          <span style="font-weight: bold; font-size: 20px">{{
            $t("bottom.p10")
          }}</span>
          <span class="inner-span white-space-nowrap">{{
            $t("bottom.p2")
          }}</span>
          <div class="flex flex-column">
            <span class="inner-span">{{ $t("bottom.p3") }}</span>
            <span class="inner-span">{{ $t("bottom.p4") }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <p>{{ $t("bottom.p9") }}</p>
        <ul class="flex" style="display: flex">
          <li>
            <el-popover placement="top" width="200" trigger="hover">
              <!-- <el-button slot="reference">hover 激活</el-button> -->
              <img
                style="width: 180px"
                src="../assets/images/weis-qr.png"
                alt=""
                srcset=""
              />
              <img
                slot="reference"
                src="../assets/images/weis.png"
                alt=""
                srcset=""
              />
            </el-popover>
          </li>
          <li>
            <el-popover placement="top" width="200" trigger="hover">
              <!-- <el-button slot="reference">hover 激活</el-button> -->
              <img
                style="width: 180px"
                src="../assets/images/weix-qr.jpg"
                alt=""
                srcset=""
              />
              <img
                slot="reference"
                src="../assets/images/weix.png"
                alt=""
                srcset=""
              />
            </el-popover>
          </li>
          <li>
            <img
              @click="goto('1')"
              src="../assets/images/douy.png"
              alt=""
              srcset=""
            />
          </li>
          <li>
            <img
              @click="goto('2')"
              src="../assets/images/tout.png"
              alt=""
              srcset=""
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="m-qrcode" v-else>
      <img
        class="m-auto flex"
        src="../assets/images/qrcode.png"
        :alt="$t('home.p1')"
      />
      <p class="inner-span text-center">{{ $t("bottom.p2") }}</p>
      <p class="inner-span text-center">{{ $t("bottom.p3") }}</p>
    </div>
    <p class="copy-r">
      COPYRIGHT © 2002-2024 333F.COM.INC.ALL RIGHTS RESERVED.<br />
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备10217460号</a>

      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=44011202004057"
        target="_blank"
        rel="noopener noreferrer"
        class="beian-link"
        aria-label="在新窗口中打开：粤公网安备44011202004057号"
      >
        <img
          src="../assets/images/beian.png"
          alt="备案图标"
          class="beian-img"
        />
        <span>粤公网安备44011202004057号</span>
      </a>
    </p>
  </div>
</template>

<script>
// import { navbar } from "../common";
// import Sidentify from "./identify";

const verificationLen = 4; // 配置验证码的长度

export default {
  name: "bottom",
  // components: { Sidentify },
  props: {
    screenWidth: {
      type: Number,
    },
  },
  data() {
    return {
      // navbar,
      verificationLen,
      ruleForm: {
        phone: "",
        verification: "",
      },
      normalVerification: "",
      size: "mini",
    };
  },
  mounted() {},
  methods: {
    goto(type) {
      if (type == "1") {
        window.open(
          "https://www.douyin.com/user/MS4wLjABAAAAPPuyTOLlpVPZxOiIq1uKoKKk-8z0-Ap2nY7U-VBijgwkMtvDo-Mq6ziHLKKm5MqR?from_tab_name=main",
          "_blank"
        );
      } else {
        window.open(
          "https://www.toutiao.com/c/user/token/MS4wLjABAAAAzP5Q_k_-ScvCPsyWN8T6quZR15E1sKEgRM9VNOYoVXZ7awGWxkyVmz0sWKkYzDHn/?entrance_gid=7230726690937242147&log_from=899317232263b_1729064016073",
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .footer {
//   width: 100%;
//   font-size: 16px;
//   color: #fff;
//   background-color: #404040;
//   box-sizing: border-box;

.footer__normal {
  // height: 280px;
  padding: 35px 0 0;
  // padding: 35px 240px 0;
}

// }

.qrcode {
  flex-shrink: 0;
  width: 150px;
  height: 150px;
  margin-right: 15px;
}

.m-qrcode {
  color: #fff;

  img {
    width: 110px;
    height: 110px;
  }

  .inner-span {
    font-size: 18px;
    margin: 20px 0 0;
    // padding-bottom: 2px;

    &:nth-child(3) {
      color: @primaryColor;
      font-size: 20px;
      letter-spacing: 1px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
}

.address {
  // height: 100px;
  .inner-span {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.5px;
    color: #ffffff;
    margin-top: 2px;

    &:nth-child(2) {
      margin-bottom: 32px;
      margin-top: 5px;
    }
  }
}

.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  height: 100px;

  li {
    margin: 0 10px;
    cursor: pointer;
  }

  p {
    font-size: 18px;
    font-weight: bold;
  }
}

p {
  font-size: 12px;

  a {
    color: #fff;
  }
}

.copy-r {
  font-family: MicrosoftYaHei;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-align: center;
  padding-top: 23px;
}

.beian-link {
  color: #fff;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  margin-left: 30px;
}

.beian-link span {
  line-height: 1;
}

.beian-img {
  width: 16px;
  height: auto;
  margin-right: 10px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue